<div class="navbar navbar-icon-top navbar-expand-lg navbar-dark bg-inverse">
  <div class="info-container" *ngIf="!loadingPict">
    <img class="profile-circle" [src]="profilePict" alt="Perfil" />
    <button
      *ngIf="!isMobile"
      mat-mini-fab
      type="button"
      class="add-image-profile font-clear"
      (click)="openFile($event)"
    >
      <mat-icon class="d-inline-flex align-items-center justify-content-center w-100 h-100">add</mat-icon>
    </button>
  </div>
  <input #avatar type="file" style="display: none" (change)="handleFileInput($event)" accept="image/*" />
  <div *ngIf="loadingPict" class="pl-3 py-2">
    <mat-spinner color="primary" mode="indeterminate" diameter="50"></mat-spinner>
  </div>
</div>
